import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton, Stack } from '@qbe/ads-core';
import { CustomContentProps, useSnackbar } from 'notistack';
import * as React from 'react';

export type SnackbarSurveyChildrenProps = {
  close: () => void;
};

interface SnackbarSurveyItemProps extends CustomContentProps {
  children: ({ close }: SnackbarSurveyChildrenProps) => React.ReactElement;
  ref?: React.Ref<unknown>;
}

export const SnackbarSurveyItem = (props: SnackbarSurveyItemProps) => {
  const { ref, ...rest } = props;
  const { closeSnackbar } = useSnackbar();
  const { id, children } = rest;

  const handleDismiss = () => {
    closeSnackbar(id);
  };

  return (
    <Box
      ref={ref}
      sx={{
        width: {
          sm: '380px',
          md: '466px',
        },
        background: 'white',
        boxShadow: '0 4px 8px 0 rgba(0,0,0,0.2)',
        padding: 4,
      }}
    >
      <Stack direction="row" spacing={1}>
        <Box sx={{ flex: 1 }}>
          {children({
            close: () => closeSnackbar(id),
          })}
        </Box>
        <Box>
          <IconButton
            iconProps={{ muiIcon: CloseIcon, color: 'inherit' }}
            onClick={handleDismiss}
          />
        </Box>
      </Stack>
    </Box>
  );
};
